import React from 'react';
import {Route, IndexRoute, IndexRedirect} from 'react-router';
import Loadable from 'react-loadable';
import Spinner from '../Spinner';
import ImageSourceList from './ImageSource/ImageSourceList';
import ImageSourceAdd from './ImageSource/ImageSourceAdd';
import ImageSourceEdit from "./ImageSource/ImageSourceEdit";
import ImageSourceDeviceList from "./ImageSourceDevices/ImageSourceDeviceList";
import ImageSourceDeviceAdd from "./ImageSourceDevices/ImageSourceDeviceAdd";
import ImageSourceDeviceEdit from "./ImageSourceDevices/ImageSourceDeviceEdit";
import ImageTagList from "./ImageTags/pages/ImageTagList";
import ImageTagAdd from "./ImageTags/pages/ImageTagAdd";
import ImageTagEdit from "./ImageTags/pages/ImageTagEdit";

const IDaqHome = Loadable({
  loader: () => import('./IDaqHome'),
  loading: () => <Spinner/>
});

export const IDaqRoute = () => (
  <Route component={IDaqHome} name={'view idaq'}>
    <IndexRedirect to='image_source'/>

    <Route path='image_source' component={ImageSourceList}>
      <Route path='add' component={ImageSourceAdd}/>
      <Route path=':id' component={ImageSourceEdit}/>
      <Route path=':id'>
        <Route path='devices'
          components={{main: ImageSourceDeviceList, sidebar: ImageSourceList}}
        >
          <Route path="add" component={ImageSourceDeviceAdd} />
          <Route path=":deviceId" component={ImageSourceDeviceEdit} />
        </Route>
      </Route>
    </Route>

      <Route path="image-tag" component={ImageTagList} name="view image-tag" >
          <Route path="add" component={ImageTagAdd} name="modify image-tag" />
          <Route path=":id" component={ImageTagEdit} name="modify image-tag" />
          {/*<Route path=":id/parameter" component={checkRolePermission(TagImage)} name="modify tag" />*/}
      </Route>

  </Route>
);



// WEBPACK FOOTER //
// ./src/components/IDaq/routes.js